import { useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useVersioning } from '../../versioning'
import { useAnalytics, RouteParams } from '@sketch/modules-common'

// TODO: Rename this component to be consistent with FrameGroup
// https://linear.app/sketch/issue/SWEB-500/rename-common-components-between-artboards-and-frames-to

export type GoToArtboardEventActionType =
  | 'keyPressEnter'
  | 'doubleClick'
  | 'CTA'
  | 'layerListAction'
  | 'contextMenuAction'

/**
 * Returns a navigateToFrame callback.
 */
export function useNavigateToFrame() {
  const history = useHistory()
  const getArtboardViewUrlFromUUID = useGetArtboardViewUrlFromUUID()
  const { trackEvent } = useAnalytics()

  const navigateToFrame = useCallback(
    (uuid: string, actionType: GoToArtboardEventActionType) => {
      trackEvent('CANVAS - open artboard', { actionType })
      history.push(getArtboardViewUrlFromUUID(uuid))
    },
    [trackEvent, history, getArtboardViewUrlFromUUID]
  )

  return navigateToFrame
}

/**
 * Provide a function that takes an artboard UUID and builds the URL
 * to access the artboard.
 */
function useGetArtboardViewUrlFromUUID() {
  const { getPathname } = useVersioning()
  const { shareID } = useParams<RouteParams<'SHARE_PAGE_CANVAS_VIEW'>>()

  const getArtboardUrlFromUUID = useCallback(
    (frameGroupUUID: string) => {
      return getPathname({
        routeKey: 'FRAME',
        routeParams: {
          shareID: shareID,
          frameUUID: frameGroupUUID,
        },
      })
    },
    [getPathname, shareID]
  )

  return getArtboardUrlFromUUID
}
